import React from "react";

export default function RefreshIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.54543 8.1629C6.33021 8.10612 6.15133 7.95667 6.05716 7.75499C5.963 7.5533 5.96329 7.32021 6.05795 7.11875L7.7187 3.58436C7.84246 3.32098 8.10742 3.15296 8.39843 3.15332C8.68944 3.15368 8.95398 3.32235 9.07709 3.58604L9.80971 5.15528C9.83591 5.14499 9.86295 5.13606 9.89078 5.1286C14.2381 3.96373 18.7067 6.54364 19.8715 10.891C21.0364 15.2383 18.4565 19.7069 14.1091 20.8717C9.7618 22.0366 5.29326 19.4567 4.12839 15.1094C3.75797 13.7269 3.7663 12.33 4.09074 11.0313C4.19112 10.6294 4.59828 10.385 5.00015 10.4854C5.40201 10.5858 5.6464 10.993 5.54602 11.3948C5.28172 12.4528 5.27444 13.5909 5.57728 14.7211C6.52774 18.2683 10.1738 20.3733 13.7209 19.4229C17.2681 18.4724 19.3731 14.8264 18.4226 11.2792C17.4877 7.79007 13.9447 5.69626 10.4531 6.53331L11.1923 8.11661C11.3154 8.3803 11.2748 8.69141 11.0882 8.91474C10.9017 9.13807 10.6027 9.23331 10.3214 9.15907L6.54543 8.1629Z"
        fill="#585B67"
      />
    </svg>
  );
}
